export default "__VITE_ASSET__BfrfWm6N__"